import etReferenceDataConfig from '@/api/config/etReferenceDataConfig'
import { queryKeys } from '@/constant/common'
import { UpdateHistorical } from '@/types/historical'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function updateEtReference(payload: UpdateHistorical): Promise<void> {
  await etReferenceDataConfig.update(payload)
}

function useUpdateReference() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation(
    (payload: UpdateHistorical) => updateEtReference(payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([queryKeys.etReference])
        toast.success(t('updateEtReferenceSuccess'))
        closeSidebar()
      },
      onError: (error: any) => {
        if (error?.statusCode === 400) {
          toast.error(error?.message)
        } else toast.error(t('updateEtReferenceError'))
      },
    },
  )
}

export default useUpdateReference
